import { useRef } from 'react'
import { useSafeState } from './use-safe-state'

import { useInterval } from './use-interval'

/**
 * This hook periodically updates itself and returns the current timestamp normalized to the interval.
 * This allows multiple components that use this hook to render the item in sync, even if the timer is off
 * by a small margin.
 *
 * @param {number} interval - refresh interval
 * @returns {number} current time
 */
export function useCurrentTime(interval = 1000) {
    const [now, setNow] = useSafeState(Math.floor(Date.now() / interval) * interval)
    const nowRef = useRef(now)
    nowRef.current = now

    useInterval(() => {
        if (Date.now() - nowRef.current >= interval) {
            setNow(Math.floor(Date.now() / interval) * interval)
        }
    }, Math.min(250, interval / 25))

    return now
}
